<template>
  <app-modal name="company-list-modal" class="company-list-modal" :title="title" @before-open="beforeOpen" hide-footer>
    <div class="customer-list">
      <app-list-items
        :list-items="companies"
        @on-click="onClick"
      >
      </app-list-items>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal';
import AppListItems from '@/components/app-list-items';
import { formatCompanyName } from '@/utils/text';
import NumericUtils from '@/utils/numeric';

export default {
  name: 'AppCustomerListModal',
  components: {
    AppModal,
    AppListItems,
  },
  data() {
    return {
      type: 'customer',
      companies: [],
    };
  },
  computed: {
    title() {
      return `${this.type === 'customer' ? this.$t('app.customerList') : this.$t('app.partnerList')}`;
    },
  },
  methods: {
    calculateTotal(company) {
      if (this.type === 'customer') {
        return company.receivable_debt ? NumericUtils.formatNumber(company.receivable_debt, 'currency') : 0;
      }
      return company.debt ? NumericUtils.formatNumber(company.debt, 'currency') : 0;
    },
    beforeOpen(params) {
      let companies = params.companies.data;
      companies = companies.map((c => ({
        ...c,
        name: formatCompanyName(c.company_name),
        total: this.calculateTotal(c),
        description: c.values ?
          NumericUtils.formatNumber(c.values, 'currency')
          : 0,
      })));
      this.companies = companies.sort((a, b) => b.values - a.values);
      this.type = params.type;
    },
    onClick($event, company) {
      this.$modal.hide('company-list-modal', { isOk: true });
      this.$router.push({
        name: this.type,
        params: {
          id: company.id,
        },
        query: this.$route.query,
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/customer/company-list-modal.vue